import { render, staticRenderFns } from "./LiveEditPage.vue?vue&type=template&id=ca0dbf02"
import script from "./LiveEditPage.vue?vue&type=script&lang=js"
export * from "./LiveEditPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports